import React from 'react'
import movie from "../../../img/Movie.png"
import useIsInViewport from 'use-is-in-viewport'

function MovieReview() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="project">
				<img alt="movie reviews website" src={movie}/>
				<div className="info">
				<h2>Movie Reviews Website 🎬</h2>   
				<div className="links">
					<a href="https://www.youtube.com/watch?v=Vh9QM4H6Em0&feature=youtu.be">Demo</a> 
					<a href="https://github.com/jguzz/Movie-Reviews-Website">Github</a> 
				</div>
				<br/>
				<h4>A full stack web application for Movie Reviews with live movie data.</h4>
				<p>- Backend created using <strong>Ruby on Rails</strong>, <strong>ActiveRecord</strong>, and <strong>SQLite</strong>.<br/>
				- Utilized The <strong>Movie Database API</strong> to pull, parse and seed data on all the most popular movies.<br/>
				- Implemented user interface employing <strong>HTML</strong> with <strong>Ruby</strong> and <strong>Bootstrap</strong> for styling.</p><br/>
				</div>
			</div>
	  	</div>
	  )
}

export default MovieReview